import axios from "axios";
import dayjs from "dayjs";

export const PAYMENT_TERM_OPTIONS = ["60 days"];

export const EXCLUSIVITY_PERIOD_OPTIONS = ["30 days", "60 days", "90 days", "6 months"];

export const EXCLUSIVITY_CATEGORY_OPTIONS = [
	"Athletic footwear & apparel",
	"Beauty & skincare",
	"Food & beverage",
	"Consumer electronics",
];

export const SUGGESTED_COMPETITORS = ["Under Armour", "Asics", "New Balance", "Fila"];

export const formatDisplayDate = (value: string): string => (value ? dayjs(value).format("MMM D, YYYY") : "");

export const getApiErrorMessage = (error: unknown, fallback: string): string => {
	if (!axios.isAxiosError(error)) return fallback;
	const data = error.response?.data as { message?: string; error?: string } | undefined;
	return data?.error || data?.message || fallback;
};
